import { useDataChange } from 'Simple/Data.js'
export function useOnChange(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.selected.filters.type = value
      next.selected.filters.value_to = []
    })
  }
}
